export default __webpack_public_path__ + "static/media/calendarlogo2.ac3f5a13.png";